import BaseSerializer from './Base';
import WMTS from 'ol/source/WMTS';
import {toSize} from 'ol/size';

class WMTSSerializer extends BaseSerializer {
    constructor() {
        super();
        this.sourceCls = WMTS;
    }

    serialize(layer, source) {
        this.validateSource(source);

        let projection = source.getProjection();
        let tileGrid = source.getTileGrid();
        let dimensions = source.getDimensions();
        let dimensionKeys = Object.keys(dimensions);
        let matrixIds = tileGrid.getMatrixIds();
        let matrices = [];
        matrixIds.forEach((matrix, idx) => {
            let sqrZ = Math.pow(2, idx);
            let matrixSize = [sqrZ, sqrZ];
            let fullTileRange = tileGrid.getFullTileRange(idx);
            if(fullTileRange){
                matrixSize = [(fullTileRange.maxX - fullTileRange.minX) + 1, (fullTileRange.maxY - fullTileRange.minY) + 1];
            }
            matrices.push({
                identifier: matrix,
                scaleDenominator: tileGrid.getResolution(idx) *
                    projection.getMetersPerUnit() / 0.28E-3,
                tileSize: toSize(tileGrid.getTileSize(idx)),
                topLeftCorner: tileGrid.getOrigin(idx),
                matrixSize: matrixSize,
            });
        });

        let serialized = {
            baseURL: source.getUrls() ? source.getUrls()[0] : window.location.href.split(/[?#]/)[0].replace(/^\/|\/$/g, ''),
            dimensions: dimensionKeys,
            dimensionParams: dimensions,
            imageFormat: source.getFormat(),
            layer: source.getLayer(),
            matrices: matrices,
            matrixSet: source.getMatrixSet(),
            opacity: layer.getOpacity(),
            requestEncoding: source.getRequestEncoding(),
            style: source.getStyle(),
            type: 'WMTS',
            version: source.getVersion()
        };
        return serialized;
    }
};

export default WMTSSerializer;